module.exports = {"news_details":{"button_back":["Retour","Back"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/News/translations/translations_news_details.json
// module id = 686
// module chunks = 0